/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { setCookie } from '@/utils/cookie';
import { analyticsGlobalPreferredVehicle } from '@/utils/analytics/dataLayer/analyticsGlobalPreferredVehicle';
import type { VehicleSummary } from '@/types';
import { type VehiclesInfo } from '../interface';
import { isServer } from '@/utils/isServer';

export const trackPreferredVehicleData = (ymme: VehicleSummary | VehiclesInfo) => {
  if (!isServer) {
    void setCookie('preferredVehicleYear', ymme.year || '');
    void setCookie('preferredVehicleMake', ymme.make || '');
    void setCookie('preferredVehicleModel', ymme.model || '');
    void setCookie(
      'preferredVehicleEngine',
      ymme.vehicleName.replace(`${ymme.year} ${ymme.make} ${ymme.model}`, '').trim() || '',
    );
    void setCookie('preferredVehicleId', ymme.catalogVehicleId || '');
    analyticsGlobalPreferredVehicle();
  }
};
